export default __webpack_public_path__ + "static/media/close.6a9515d8.svg";